import { industryPayrollThreshold } from 'common/constants';

export interface UnderwritingQuestionsState {
  numEmployees?: string | number;
  payrollW2?: string | number;
}

export interface PolicyCharacteristics {
  pol_tax_industry?: string;
}

/**
 * Determines if the low payroll per employee worksheet should be shown.
 * Condition: (numEmployees > 1) AND (payrollW2 / numEmployees < INDUSTRY_THRESHOLD)
 * Only triggers when the industry has a defined threshold.
 */
export function isLowPayrollPerEmployeeTriggered(
  state: UnderwritingQuestionsState,
  characteristics: PolicyCharacteristics | null | undefined,
): boolean {
  if (!characteristics?.pol_tax_industry) return false;

  const selectedIndustryPayroll = industryPayrollThreshold[characteristics.pol_tax_industry];
  if (selectedIndustryPayroll === undefined) return false;

  const numEmployees = Number(state?.numEmployees ?? 0);
  const payrollW2 = Number(state?.payrollW2 ?? 0);

  if (numEmployees <= 1) return false;

  const payrollPerEmployee = payrollW2 / numEmployees;

  return payrollPerEmployee < selectedIndustryPayroll;
}
